import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import AddressMap from "./AddressMap";
import normalize from "../utils/NormalizeSelect";

const LegalAddress = ({
  data,
  processData,
  error,
  setData,
  setError,
  column = 1,
}) => {
  const [areas, setAreas] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [streets, setStreets] = useState([]);
  const location = useLocation();
  const { id } = useParams();
  const { pathname } = location;
  const token = localStorage.getItem("token");

  const fetchAreaList = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}location/areas`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setAreas(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchBlockList = () => {
    const areaName = encodeURIComponent(data?.legalArea?.value);
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}location/blocks/${areaName}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setBlocks(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchStreetList = () => {
    const areaName = encodeURIComponent(data?.legalArea?.value);
    const blockName = encodeURIComponent(data?.legalBlock?.value);
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}location/streets/${areaName}/${blockName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.code === 1) {
          setStreets(res.data.data);
        }
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchAreaList();
  }, []);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame !== true) {
      setBlocks([]);
      setStreets([]);
      setData({
        ...data,
        legalBlock: null,
        legalStreet: null,
      });
      setError({
        ...error,
        legalBlock: null,
        legalStreet: null,
      });
      fetchBlockList();
    }
  }, [data?.legalArea]);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame !== true) {
      setStreets([]);
      setData({
        ...data,
        legalStreet: null,
      });
      setError({
        ...error,
        legalStreet: null,
      });
      fetchStreetList();
    }
  }, [data?.legalBlock]);
  useEffect(() => {
    if (pathname === `/delivary-companies/edit-delivary-company/${id}`) {
      setData({
        ...data,
        legalStreet: data?.legalStreet,
      });
    }
  }, [data?.legalStreet]);

  return (
    <>
      <div className="card-header">
        <div className="card-title">Legal Address</div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className={column === 2 ? "col-md-6" : "col-md-12"}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label required">Area</label>

                <Select
                  className="react-select-styled react-select-bordered"
                  classNamePrefix="react-select"
                  value={
                    data?.legalArea
                      ? {
                        label: data?.legalArea?.value,
                        value: data?.legalArea,
                      }
                      : null
                  }
                  onChange={(e) => {
                    processData("select", e, "legalArea");
                  }}
                  options={areas?.map((item) => {
                    return {
                      label: item?.value,
                      value: item,
                    };
                  })}
                  filterOption={(option, input) => {
                    return normalize(option.label).includes(normalize(input));
                  }}
                  isDisabled={data?.billingAndLegalAddressSame ?? false}
                  placeholder="Select an option"
                />
                {error.legalArea !== undefined && error.legalArea !== "" ? (
                  <small className="text-danger mt-2">{error.legalArea}</small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Block</label>
                <Select
                  className="react-select-styled react-select-bordered"
                  classNamePrefix="react-select"
                  value={
                    data?.legalBlock
                      ? {
                        label: data?.legalBlock?.value,
                        value: data?.legalBlock,
                      }
                      : null
                  }
                  onChange={(e) => {
                    setStreets([]);
                    processData("select", e, "legalBlock");
                  }}
                  options={blocks?.map((item) => {
                    return {
                      label: item?.value,
                      value: item,
                    };
                  })}
                  filterOption={(option, input) => {
                    return normalize(option.label).includes(normalize(input));
                  }}
                  isDisabled={data?.billingAndLegalAddressSame ?? false}
                  placeholder="Select an option"
                />
                {error.legalBlock !== undefined && error.legalBlock !== "" ? (
                  <small className="text-danger mt-2">{error.legalBlock}</small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-12 mb-3">
                <label className="form-label required">Street</label>
                <Select
                  className="react-select-styled react-select-bordered"
                  classNamePrefix="react-select"
                  value={
                    data?.legalStreet
                      ? {
                        label: data?.legalStreet?.value,
                        value: data?.legalStreet,
                      }
                      : null
                  }
                  onChange={(e) => {
                    processData("select", e, "legalStreet");
                  }}
                  options={streets?.map((item) => {
                    return {
                      label: item?.value,
                      value: item,
                    };
                  })}
                  filterOption={(option, input) => {
                    return normalize(option.label).includes(normalize(input));
                  }}
                  isDisabled={data?.billingAndLegalAddressSame ?? false}
                  placeholder="Select an option"
                />
                {error.legalStreet !== undefined && error.legalStreet !== "" ? (
                  <small className="text-danger mt-2">
                    {error.legalStreet}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">
                  Building Number or Name
                </label>
                <input
                  id="legal_building_no_or_name"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Building Number or Name"
                  data-error="* Please Enter Buiding No."
                  value={data?.legalBuildingNoOrName ?? ""}
                  disabled={data?.billingAndLegalAddressSame ?? false}
                  onChange={(e) => {
                    processData("text", e, "legalBuildingNoOrName");
                  }}
                />
                {error.legalBuildingNoOrName !== undefined &&
                  error.legalBuildingNoOrName !== "" ? (
                  <small className="text-danger mt-2">
                    {error.legalBuildingNoOrName}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Jadda</label>
                <input
                  id="legal_jadda"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Enter Jadda"
                  data-error="* Please Enter Jadda"
                  value={data?.legalJadda ?? ""}
                  disabled={data?.billingAndLegalAddressSame ?? false}
                  onChange={(e) => {
                    processData("text", e, "legalJadda");
                  }}
                />
                {error.legalJadda !== undefined && error.legalJadda !== "" ? (
                  <small className="text-danger mt-2">{error.legalJadda}</small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Apartment/Office</label>
                <input
                  id="legal_apartment_or_office"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Apartment or Office Details"
                  data-error="* Apartment or Office Details"
                  value={data?.legalApartmentOrOffice ?? ""}
                  disabled={data?.billingAndLegalAddressSame ?? false}
                  onChange={(e) => {
                    processData("text", e, "legalApartmentOrOffice");
                  }}
                />
                {error.legalApartmentOrOffice !== undefined &&
                  error.legalApartmentOrOffice !== "" ? (
                  <small className="text-danger mt-2">
                    {error.legalApartmentOrOffice}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Floor</label>
                <input
                  id="legal_floor"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Enter Floor"
                  data-error="* Floor Details"
                  value={data?.legalFloor ?? ""}
                  disabled={data?.billingAndLegalAddressSame ?? false}
                  onChange={(e) => {
                    processData("text", e, "legalFloor");
                  }}
                />
                {error.legalFloor !== undefined && error.legalFloor !== "" ? (
                  <small className="text-danger mt-2">{error.legalFloor}</small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Latitude</label>
                <input
                  id="legal_latitude"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Enter Latitude"
                  data-error="* Latitude Details"
                  value={data?.legalLatitude ?? ""}
                  disabled={data?.billingAndLegalAddressSame ?? false}
                  onChange={(e) => {
                    processData("text", e, "legalLatitude");
                  }}
                />
                {error.legalLatitude !== undefined &&
                  error.legalLatitude !== "" ? (
                  <small className="text-danger mt-2">
                    {error.legalLatitude}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Longitude</label>
                <input
                  id="legal_longitude"
                  type="text"
                  className="form-control add-delivery-company-field"
                  placeholder="Enter Longitude"
                  data-error="* Longitude Details"
                  value={data?.legalLongitude ?? ""}
                  disabled={data?.billingAndLegalAddressSame ?? false}
                  onChange={(e) => {
                    processData("text", e, "legalLongitude");
                  }}
                />
                {error.legalLongitude !== undefined &&
                  error.legalLongitude !== "" ? (
                  <small className="text-danger mt-2">
                    {error.legalLongitude}
                  </small>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className={column === 2 ? "col-md-6 pt-5" : "col-md-12 pt-5"}>
            <div
              className={
                data?.billingAndLegalAddressSame === true
                  ? "map-disabled mt-5"
                  : "mt-5"
              }
              style={{ height: "350px", width: "100%" }}
              id="legalAddressMap"
            >
              <AddressMap
                data={data}
                setData={setData}
                setErrors={setError}
                type="legal"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LegalAddress;
